import React from "react"
import CaseStudy from "components/CaseStudy"
import CaseStudyProvider from "components/CaseStudyProvider"
import styles from "./styles.scss"
import Screenshot from "./Screenshot"
import screenshotOne from "images/miasano-screen-four.png"
import screenshotTwo from "images/miasano-screen-one.png"
import screenshotThree from "images/miasano-screen-two.png"

class Learn2EsportCaseStudy extends React.Component {
  render() {
    return (
      <CaseStudyProvider
        render={caseStudies => {
          const caseStudy = caseStudies.find(x => x.company === "Miasano")
          return (
            <CaseStudy
              caseStudy={caseStudy}
              heroBackgroundOpacity={0.7}
              renderSummary={() => (
                <React.Fragment>
                  <p>
                    Vi hjälpte Miasano att utveckla en mobilapp som underlättar
                    livet för människor med hypertyreos. Med appen kan de på ett
                    enkelt sätt följa sina symptom och medicinintag.
                  </p>
                  <p>
                    Vi skapade en journal som fylls i dagligen. Dessa i sin tur
                    genererar grafer som en läkare kan ta till hjälp för att
                    bestämma om medicinerna ska ändras eller inte.
                  </p>
                </React.Fragment>
              )}
              renderProblem={() => (
                <React.Fragment>
                  <p>
                    En person som lider av hypertyreos kan ha mer än 50 olika
                    symptom och behöva ta ett tiotal mediciner dagligen. Dessa
                    mediciner kan i sin tur behöva bytas beroende på hur
                    symptomen förändras.
                  </p>
                  <p>
                    Personer som drabbas av hypertyreos är oftast äldre, därför
                    behövde appen utvecklas för att passa även de som saknar
                    teknikvana.
                  </p>
                </React.Fragment>
              )}
              renderDesign={() => (
                <React.Fragment>
                  <p>
                    Vi på SAITS hade många samtal och genomgångar med Miasano
                    för att skapa förståelse och få insikt i hur en person med
                    hypertyreos lever. Detta för att vi skulle kunna skapa ett
                    bra flöde i appen som gör det enkelt för personerna i
                    målgruppen att använda den.
                  </p>
                  <p>
                    En stor del av lösningen var att skapa pushnotiser som
                    påminner användaren när det är dags att ta sin medicin eller
                    fylla i den dagliga journalen. Detta för att bilda en bättre
                    graf som i sin tur ger läkaren en bättre idé om vilka
                    mediciner som hjälper.
                  </p>
                  <div className={styles.screenshots}>
                    <Screenshot
                      image={screenshotOne}
                      alt="Skärmdump på login-vyn för appen."
                    />
                    <Screenshot
                      image={screenshotTwo}
                      alt="Skärmdump på journalen där användaren dagligen fyller i sina symptom i appen."
                    />
                    <Screenshot
                      image={screenshotThree}
                      alt="Skärmdump på hemsidan för appen där användaren kan se en översikt över sina symptom."
                    />
                  </div>
                  <p>
                    Miasano ville ha appen både till iOS och Android för att nå
                    ut till så många personer som möjligt. Därför använde vi oss
                    av React Native. Att kunna skriva JavaScript som genererar
                    två appar som ser likadana ut (bortsett från
                    plattformsspecifika beteenden) för de två plattformarna är
                    en perfekt lösning för både kund och företag.
                  </p>
                </React.Fragment>
              )}
              renderTechnology={() => (
                <React.Fragment>
                  <h3>Frontend / Backend</h3>
                  <p>
                    Appen är skriven i React Native, vilket innebär att man
                    skriver JavaScript med tillägget JSX för att beskriva hur
                    appen ska se ut. Fördelen med detta är att det bara behövs
                    skrivas kod på ett ställe som sedan omvandlas till Android
                    och iOS-kod. Detta tillsammans med en bra Webpack och
                    Scss-setup ledde till en smidig utvecklingsmiljö.
                  </p>
                  <p>
                    För att snabbt få igång ett API som senare är enkelt att
                    skala användes ett Ruby on Rails REST API tillsammans med en
                    PostgreSQL-databas.
                  </p>
                  <h3>Notifikationer</h3>
                  <p>
                    En viktig del av appen är notifikationerna. En användare har
                    ofta ett flertal mediciner att hålla koll på, som dessutom
                    kan behöva tas vid olika tider. Utöver det ska den dagliga
                    journalen fyllas i för att graferna ska vara så exakta som
                    möjligt. Då är det till stor hjälp att användaren får en
                    notis/notifikation för att slippa hålla den informationen i
                    huvudet.
                  </p>
                  <p>
                    Eftersom det handlar om människors hälsa är det givetvis
                    extremt viktigt att dessa notiser anländer i rätt tid, så
                    att inga mediciner missas. Detta ordnade vi genom skapa en
                    lokal notifikation varje gång en användare lägger till ett
                    medicintillfälle. Tack vare denna lösning skickas notisen
                    oavsett om appen är igång eller ej.
                  </p>
                </React.Fragment>
              )}
            />
          )
        }}
      />
    )
  }
}

export default Learn2EsportCaseStudy



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/MiasanoCaseStudy/index.jsx